import { motion } from "framer-motion";

const EASE = [0.2, 0.75, 0.1, 1];

const lineV = {
  hidden: { y: "108%" },
  show: ({ i, d }) => ({ y: "0%", transition: { duration: 1.1, ease: EASE, delay: d + i * 0.11 } }),
};

export const MaskLines = ({ lines, className = "", lineClass = "", onMount = false, delay = 0, testid }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(onMount ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.1 } })}
    data-testid={testid}
  >
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.06em]">
        <motion.span className={`block ${lineClass}`} variants={lineV} custom={{ i, d: delay }}>
          {l}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const FadeUp = ({ children, className = "", delay = 0, as = "div", ...rest }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </M>
  );
};

export const Rule = ({ className = "" }) => (
  <motion.div
    className={`h-px bg-[var(--line)] origin-left ${className}`}
    initial={{ scaleX: 0 }}
    whileInView={{ scaleX: 1 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 1.4, ease: EASE }}
  />
);
